export default __webpack_public_path__ + "static/2.2_FR-87fb1e7e98b6923158a4e17c25bdc8e9.webp";